import { LOCALE_QUERY_KEY } from "@/misc/constants";
import { useParsedQuery } from "./useParsedQuery";

export const useExtractHL = () => {
  const query = useParsedQuery();
  return query[LOCALE_QUERY_KEY];
};
